import React, {useMemo} from 'react'
import {fill} from '../../utils/ApColor'

const EventBox = ({data, onClick}) => {
  const {
    border_color,
    background_color,
    variants = [],
    title,
    description,
    overdue_height,
  } = useMemo(() => {
    const [title, ...description] = data.title.split(', ')

    const item = data.event
    /**
     *  Color of event based upon calendar view selected (Default)
     */
    let border_color = item.bgColor || '#fff'
    let background_color = `${item.bgColor}22` || '#fff'
    let overdue_height = 0
    let variants = []

    if (item.type === 'SystemReservationAction') {
      /**
       *  Dotted outline for awaiting manager approval
       */
      if (item.status === 'requested' && item.state === 'pending') {
        variants.push('event-box--dotted')
        border_color = item.bgColor
        background_color = item.bgColor + '22'
        /**
         * Solid outline for manager approved events
            Or events not requiring approval
        */
      } else if (item.status === 'upcoming') {
        variants.push('event-box--solid')
        border_color = item.bgColor
        background_color = item.bgColor + '22'
      }

      // check overdue
      if (!!item.action_return_date && item.end.valueOf() < item.action_return_date.valueOf()) {
        let _diff = item.action_return_date.valueOf() - item.end.valueOf()
        let _diff2 = item.action_return_date.valueOf() - item.start.valueOf()
        let _perc = (_diff / _diff2) * 100
        overdue_height = Math.min(_perc, 100)
      }
    }

    return {variants, border_color, background_color, overdue_height, title, description}
  }, [data])

  return (
    <div
      className={`event-box ${variants.join(' ')}`}
      onClick={e => onClick(data.event)}
      style={{
        top: data.top + '%',
        bottom: 100 - data.bottom + '%',
        left: data.left + 'px',
        width: data.right - 7 + 'px',
        borderColor: border_color,
        backgroundColor: fill(background_color, 0.3),
      }}
      title={data.title}
    >
      <div className="event-box__title">{title}</div>
      {description.map((d, i) => (
        <div key={i} className="event-box__desc">
          {d}
        </div>
      ))}
      {overdue_height > 0 && (
        <div style={{height: `${overdue_height}%`}} className="event-box__overdue-bg">
          <span className="" data-x="date-selection">
            Overdue
          </span>
        </div>
      )}
    </div>
  )
}

export default EventBox
